(function(){

// Gallery thumbnails
var thumbs=document.querySelectorAll('.thumb'),mainMedia=document.getElementById('mainMedia');
function showThumb(t){
  thumbs.forEach(x=>x.classList.remove('active'));t.classList.add('active');
  if(t.dataset.video){
    mainMedia.innerHTML='<video src="'+t.dataset.video+'" poster="'+t.dataset.poster+'" controls playsinline autoplay></video>';
  }else{
    mainMedia.innerHTML='<img src="'+t.dataset.src+'" alt="'+(t.dataset.alt||'')+'">';
  }
}
thumbs.forEach(t=>t.addEventListener('click',()=>showThumb(t)));
document.getElementById('demoCard').addEventListener('click',()=>{showThumb(thumbs[1]);document.querySelector('.gallery').scrollIntoView({behavior:'smooth',block:'start'})});

// Review carousel
(()=>{var s=[...document.querySelectorAll('.rev-slide')],p=document.getElementById('revPrev'),n=document.getElementById('revNext');var i=0;
function go(k){s[i].classList.remove('on');i=k;s[i].classList.add('on');p.disabled=i===0;n.disabled=i===s.length-1}
p.onclick=()=>go(Math.max(0,i-1));n.onclick=()=>go(Math.min(s.length-1,i+1));go(0)})();

// Bundle selection
var bundles=document.querySelectorAll('.bundle');
function syncPrice(){
  var sel=document.querySelector('.bundle.selected');
  document.querySelector('.atc-price').textContent=sel.dataset.price;
  document.getElementById('stickyPrice').textContent=sel.dataset.price;
  document.getElementById('stickyName').textContent='LoudLock · '+sel.dataset.name.replace('&amp;','&');
}
bundles.forEach(b=>b.addEventListener('click',()=>{bundles.forEach(x=>x.classList.remove('selected'));b.classList.add('selected');syncPrice()}));
(()=>{var v=new URLSearchParams(location.search).get('variant');if(!v)return;var b=[...bundles].find(x=>x.dataset.variant===v);if(b){bundles.forEach(x=>x.classList.remove('selected'));b.classList.add('selected')}})();
syncPrice();

// Add to cart -> Shopify cart
var adding=false;
function toast(msg){var t=document.getElementById('toast');t.textContent=msg;t.classList.add('show');setTimeout(()=>t.classList.remove('show'),2600)}
window.addToCart=async function(){
  if(adding)return; adding=true;
  var sel=document.querySelector('.bundle.selected');
  document.querySelectorAll('.atc').forEach(b=>b.style.opacity=.7);
  try{
    var r=await fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items:[{id:Number(sel.dataset.variant),quantity:1}]})});
    if(!r.ok) throw new Error(await r.text());
    window.location.href='/cart';
  }catch(e){toast('Sorry, that didn\'t work. Please try again.');adding=false;document.querySelectorAll('.atc').forEach(b=>b.style.opacity=1)}
}
document.getElementById('atc').addEventListener('click',addToCart);

// Sticky bar on mobile once main button is off screen
var sticky=document.getElementById('sticky'),atc=document.getElementById('atc');
function checkSticky(){sticky.classList.toggle('show',atc.getBoundingClientRect().bottom<0)}
window.addEventListener('scroll',checkSticky,{passive:true});checkSticky();

})();
